import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { Wrapper } from './elements';
import ActCard from 'dc/ActCard';
import { useText, useGetActivityIconUrl } from 'common/hooks';
import { getIndicatorConfig } from 'utils/common';

function noop() {
  // Do nothing
}

type Props = {
  readonly className?: string;
  readonly color?: string;
};

const deps = {
  canLog: state.challenge.log.computedCanLog,
  isLoggingSubcategory:
    state.challenge.log.activitySubCategoryLogging[
      state.appContainer.activities['activity_tutorial_01'].subCategory
    ],
  campaignIndicator: state.challenge.campaign.indicator,
  isLoggingThisActivity:
    state.challenge.log.activityKeysLogging['activity_tutorial_01'],
  tutorialActivityLogged: state.challenge.tutorial.tutorialActivityLogged,
  showTutorial: state.challenge.tutorial.show,
  toggleLogTutorialActivity: sequences`challenge.tutorial.toggleLogTutorialActivity`,
};

export function TutorialActivityCard({
  className,
  color,
  isLoggingSubcategory,
  canLog,
  campaignIndicator,
  isLoggingThisActivity,
  tutorialActivityLogged,
  showTutorial,
  toggleLogTutorialActivity,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const getActivityIconUrl = useGetActivityIconUrl();
  const indicatorConfig = getIndicatorConfig(campaignIndicator);

  return (
    <Wrapper className={className}>
      <ActCard
        ariaLabelLogButton={t('a11y.button_labels.log_activity')}
        ariaDescription={t('a11y.button_labels.learn_more')}
        title={t(`challenge.activities.activity_tutorial_01.title`)}
        ctaText={t(`challenge.activities.learn_more`)}
        indicators={[
          {
            value: '1.61',
            key: 'tutorial_activity',
            isCompetingIndicator: true,
            icon: indicatorConfig.icon,
            color: indicatorConfig.color,
          },
        ]}
        categoryColor={color}
        activityIcon={getActivityIconUrl()}
        activityIconAlt={''}
        onActivityClick={noop}
        disabled={(!canLog || isLoggingSubcategory) && !isLoggingThisActivity}
        checked={tutorialActivityLogged}
        onLogClick={() =>
          toggleLogTutorialActivity({
            offset: 0,
            co2: 1.61,
            popUpNumber: showTutorial + 1,
          })
        }
        isLogging={false}
      />
    </Wrapper>
  );
}

export default connect<Props, typeof deps>(deps, TutorialActivityCard);
